import axios from "../../../core/api/http-common";

// Challenge Theme Category
//
const ON_CREATE_CHALLENGE_THEMES_CATEGORIES =
  "/challenges/themes/categories/create";
const ON_GET_CHALLENGE_THEMES_CATEGORIES_WITH_PAGINATION =
  "/challenges/themes/categories/get/with/pagination";
const ON_GET_CHALLENGE_THEMES_CATEGORIES = "/challenges/themes/categories/get";
export function onCreateChallengeThemeCategory(axiosPrivate, data) {
  const _data = {
    title_en: data?.title_en,
    title_fr: data?.title_fr,
    description_en: data?.description_en,
    description_fr: data?.description_fr,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_CREATE_CHALLENGE_THEMES_CATEGORIES, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengeThemeCategoriesWithPagination(
  axiosPrivate,
  _data,
  signal,
) {
  const data = {
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_THEMES_CATEGORIES_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// export function onGetChallengeThemeCategories(signal) {
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .get(ON_GET_CHALLENGE_THEMES_CATEGORIES, {
//         signal: signal,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// export function onChallengeThemeCategoriesActivationOrDesactivation(
//   is_action,
//   selectedRows
// ) {
//   const _data = {
//     is_action: is_action, // "activate" or "desactivate"
//     selected_rows: selectedRows,
//     updated_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .patch(CHALLENGE_THEME + "/category/activation/desactivation", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// export function onChallengeThemeCategoriesDeletionOrRecovery(
//   is_action,
//   selectedRows
// ) {
//   const _data = {
//     is_action: is_action, // "activate" or "desactivate"
//     selected_rows: selectedRows,
//     updated_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .patch(CHALLENGE_THEME + "/category/deletion/recovery", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
//
// Challenge Theme
//

const ON_CREATE_CHALLENGE_THEMES = "/challenges/themes/create";
const ON_GET_CHALLENGE_THEMES_WITH_PAGINATION =
  "/challenges/themes/get/with/pagination";
const ON_GET_CHALLENGE_THEMES_BY_STREAM_ID_WITH_PAGINATION =
  "/challenges/themes/get/stream/id/with/pagination";
export function onCreateChallengeTheme(axiosPrivate, data) {
  const _data = {
    title_en: data?.title_en,
    title_fr: data?.title_fr,
    description_en: data?.description_en,
    description_fr: data?.description_fr,
    challenge_theme_category_id: data?.challenge_theme_category_id,
    related_streams: data?.related_streams,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_CREATE_CHALLENGE_THEMES, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengeThemesWithPagination(
  axiosPrivate,
  _data,
  signal,
) {
  const data = {
    challenge_theme_category_id: _data?.challenge_theme_category_id,
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_THEMES_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengeThemesByStreamIdWithPagination(
  axiosPrivate,
  _data,
  signal,
) {
  const data = {
    stream_id: _data?.stream_id,
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_THEMES_BY_STREAM_ID_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
const ON_PICKUP_CHALLENGE_THEMES_WITH_PAGINATION =
  "/challenges/themes/pickup/with/pagination";
const ON_PICKUP_CHALLENGE_THEMES_BY_ID_WITH_PAGINATION =
  "/challenges/themes/pickup/by/id/with/pagination";
export function onPickUpChallengeThemesWithPagination(axiosPrivate, _data, signal) {
  const data = {
    pick_question_from: _data?.pick_question_from,
    stream_id: _data?.stream_id,
    subject: _data?.subject,
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_PICKUP_CHALLENGE_THEMES_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onPickUpChallengeThemeQuestionByIdWithPagination(
  axiosPrivate,
  _data,
  signal,
) {
  const data = {
    pick_question_from: _data?.pick_question_from,
    challenge_id: _data?.challenge_id,
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_PICKUP_CHALLENGE_THEMES_BY_ID_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// export function onChallengeThemesActivationOrDesactivation(
//   is_action,
//   selectedRows
// ) {
//   const _data = {
//     is_action: is_action, // "activate" or "desactivate"
//     selected_rows: selectedRows,
//     updated_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .patch(CHALLENGE_THEME + "/activation/desactivation", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// export function onChallengeThemesDeletionOrRecovery(is_action, selectedRows) {
//   const _data = {
//     is_action: is_action, // "activate" or "desactivate"
//     selected_rows: selectedRows,
//     updated_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .patch(CHALLENGE_THEME + "/deletion/recovery", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// export function onGetChallengeThemesCategoryLinkedWithPagination(
//   axiosPrivate,
//   data,
//   signal
// ) {
//   const _data = {
//     sys_role: data?.sys_role,
//     stream_id: data?.stream_id,
//     rows_per_age: data?.rows_per_age,
//     current_page: data?.current_page,
//   };
//   return new Promise(async (resolve, reject) => {
//     await axiosPrivate
//       .get(CHALLENGE_THEME + "/linked/with/pagination", {
//         params: _data,
//         signal: signal,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
//

// Challenge Theme Questions
//
const ON_CREATE_CHALLENGE_THEMES_QUESTIONS =
  "/challenges/themes/questions/create";
const ON_GET_CHALLENGE_THEMES_QUESTIONS_WITH_PAGINATION =
  "/challenges/themes/questions/get/with/pagination";
export function onCreateChallengeThemeQuestions(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_CREATE_CHALLENGE_THEMES_QUESTIONS, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengeThemeQuestionsByChallengeThemeId(
  axiosPrivate,
  data,
  signal,
) {
  const _data = {
    challenge_theme_id: data?.challenge_theme_id,
    rows_per_page: data?.rows_per_page,
    current_page: data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_THEMES_QUESTIONS_WITH_PAGINATION, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// export function onAcivateDesactivateChallengeThemeQuestion(
//   challenge_theme_question_id,
//   is_activated
// ) {
//   const _data = {
//     challenge_theme_question_id: challenge_theme_question_id,
//     is_activated: is_activated,
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .patch(CHALLENGE_THEME + "/questions/activation/desactivation", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// export function onDeleteRecoverChallengeThemeQuestion(
//   challenge_theme_question_id,
//   is_deleted
// ) {
//   const _data = {
//     challenge_theme_question_id: challenge_theme_question_id,
//     is_deleted: is_deleted,
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .patch(CHALLENGE_THEME + "/questions/delete/recover", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
